import { postTechnicalAssistanceModule } from '../../config/apiSinToken'

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance Received
 * FECHA: 20-01-2023
 */
export const insertTechnicalAssistanceReceived = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceReceived/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance Aplicant
 * FECHA: 20-01-2023
 */
export const insertTechnicalAssistanceApplicant = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceApplicant/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance implementacionActivities
 * FECHA: 03-02-2023
 */
export const insertTechnicalAssistanceImplementationActivities = async (
  form,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/ImplementationActivities/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance implementacionActivities
 * FECHA: 03-02-2023
 */
export const insertIndigenousCommunities = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/IndigenousCommunities/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance Budget
 * FECHA: 13-02-2023
 */
export const insertTechnicalAssistanceBudget = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Technical Assistance form
 * FECHA: 20-02-2023
 */
export const insertTechnicalAssistanceAnswers = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/saveForm`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Applied Studies
 * FECHA: 23-02-2023
 */
export const insertAppliedStudies = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/AppliedStudies/InsertAppliedStudies`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT Provider List
 * FECHA: 13-03-2023
 */
export const insertProviderList = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/ProviderList/insert`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: INSERT AzureBlobStorageService
 * FECHA: 14-03-2023
 */
export const insertAzureBlobStorageService = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/AzureBlobStorageService/Upload`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: delete AzureBlobStorageService
 * FECHA: 14-03-2023
 */
export const DeleteAzureBlobStorageService = async (params) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/AzureBlobStorageService/Delete?IdAttachedDocument=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: download pdf
 * Fecha: 24-03-2023
 */
export const DownloadAzureBlobStorageService = async (param) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/AzureBlobStorageService/Download?IdAttachedDocument=${param}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: Valid mipyme limits
 * Fecha: 27-04-2023
 */
export const ValidLimits = async (form) => {
  const data = await postTechnicalAssistanceModule(
    `api/LimitProcessesTechnicalAssistance/getValidLimits`,
    form,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: report Technical Assistance Preinvestment Group Mipyme
 * Fecha: 27-04-2023
 */
export const reportTechnicalAssistancePreinvestmentGroupMipyme = async (
  idForm,
  user,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportTechnicalAssistancePreinvestmentGroupMipyme/${idForm}?usuario=${user}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: report Technical Assistance Preinvestment
 * Fecha: 27-04-2023
 */
export const reportTechnicalAssistancePreinvestment = async (idForm, user) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportTechnicalAssistancePreinvestment/${idForm}?usuario=${user}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: report capacity Building IFI
 * Fecha: 27-04-2023
 */
export const reportCapacityBuildingIFI = async (idForm, user) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuildingIFI/${idForm}?usuario=${user}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: report capacity Building
 * Fecha: 28-04-2023
 */
export const reportCapacityBuilding = async (idForm, user) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuilding/${idForm}?usuario=${user}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: report capacity Building groupmipymes
 * Fecha: 28-04-2023
 */
export const reportCapacityBuildingGroupMipyme = async (idForm, user) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuildingGroupMipyme/${idForm}?usuario=${user}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Limit Asistencia tecnica
 * Fecha: 15-5-2023
 */
export const MasterLimitsAvailable = async (param) => {
  const data = await postTechnicalAssistanceModule(
    `api/LimitProcessesTechnicalAssistance/MasterLimitsAvailable/${param}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Upload Report Technical Assistance Preinvestment GroupMipyme
 * Fecha: 1-6-2023
 */
export const UploadReportTechnicalAssistancePreinvestmentGroupMipyme = async (
  idForm,
  user,
  idHistory,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportTechnicalAssistancePreinvestmentGroupMipyme/${idForm}?usuario=${user}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Upload Report Technical Assistance Preinvestment
 * Fecha: 1-6-2023
 */
export const UploadReportTechnicalAssistancePreinvestment = async (
  idForm,
  user,
  idHistory,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportTechnicalAssistancePreinvestment/${idForm}?usuario=${user}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Upload Report Capacity Building IFI
 * Fecha: 1-6-2023
 */
export const UploadReportCapacityBuildingIFI = async (
  idForm,
  user,
  idHistory,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuildingIFI/${idForm}?usuario=${user}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Upload Report Capacity Building Group MIPYME
 * Fecha: 1-6-2023
 */
export const UploadReportCapacityBuildingGroupMipyme = async (
  idForm,
  user,
  idHistory,
) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuildingGroupMipyme/${idForm}?usuario=${user}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Upload Report Capacity Building
 * Fecha: 1-6-2023
 */
export const UploadReportCapacityBuilding = async (idForm, user, idHistory) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/attachments/reportCapacityBuilding/${idForm}?usuario=${user}&IdFormHistory=${idHistory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Description: document request no objection
 * Fecha: 05-07-2023
 */
export const documentRequestNoObjection = async (idForm, user) => {
  const data = await postTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceFormReport/TechnicalAssistanceForm/document/RequestNoObjection/${idForm}?userB2C=${user}`,
  )
  return data
}
